import { motion } from "framer-motion";
import { Quote } from "lucide-react";

const EASE = [0.16, 1, 0.3, 1];

const testimonials = [
    {
        quote: "SalesCan completely reconstructed our outbound strategy. Within 90 days, our qualified pipeline grew by 280%.",
        author: "David Miller",
        role: "VP of Revenue, Apex Tech — Toronto",
        metric: "+280% Pipeline Growth",
        image: "https://images.pexels.com/photos/37148308/pexels-photo-37148308.jpeg",
    },
    {
        quote: "The AI qualifying copilots freed up 15 hours per week for our account executives to focus solely on closing high-value deals.",
        author: "Sarah Lin",
        role: "Chief Commercial Officer, Veloce SaaS — Vancouver",
        metric: "15 hrs/wk Saved Per Rep",
        image: "https://images.pexels.com/photos/27086922/pexels-photo-27086922.jpeg",
    },
];

export default function Testimonials() {
    return (
        <section id="impact" data-testid="testimonials-section" className="px-4 sm:px-8 lg:px-16 py-24 lg:py-36">
            <div className="max-w-[1400px] mx-auto">
                <motion.div
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.9, ease: EASE }}
                    className="mb-14"
                >
                    <p className="font-mono-tech text-xs uppercase tracking-[0.3em] text-[#FF3B30] font-semibold mb-4">
                        Proof, not promises
                    </p>
                    <h2 className="font-display font-bold uppercase tracking-tight text-2xl sm:text-3xl lg:text-5xl text-white leading-tight">
                        Revenue leaders <span className="text-stroke">talk numbers.</span>
                    </h2>
                </motion.div>

                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8">
                    {testimonials.map((t, i) => (
                        <motion.figure
                            key={t.author}
                            data-testid={`testimonial-card-${i + 1}`}
                            initial={{ opacity: 0, y: 50 }}
                            whileInView={{ opacity: 1, y: 0 }}
                            viewport={{ once: true, margin: "-60px" }}
                            transition={{ duration: 0.9, delay: i * 0.15, ease: EASE }}
                            className="group relative rounded-3xl border border-white/10 bg-[#141A26]/60 p-8 sm:p-10 hover:border-[#FF3B30]/40 transition-colors duration-500 overflow-hidden"
                        >
                            <Quote className="w-8 h-8 text-[#FF3B30]/60 mb-6" />
                            <blockquote className="text-lg sm:text-xl text-slate-200 leading-relaxed font-medium">
                                "{t.quote}"
                            </blockquote>
                            <figcaption className="mt-8 flex items-center gap-4 border-t border-white/10 pt-6">
                                <img
                                    src={t.image}
                                    alt={t.author}
                                    loading="lazy"
                                    className="w-14 h-14 rounded-2xl object-cover border border-white/10"
                                />
                                <div className="min-w-0">
                                    <p className="font-display font-semibold text-white">{t.author}</p>
                                    <p className="text-sm text-slate-400 truncate">{t.role}</p>
                                </div>
                                <span className="ml-auto shrink-0 font-mono-tech text-xs uppercase tracking-widest text-[#FF3B30] border border-[#FF3B30]/30 bg-[#FF3B30]/10 rounded-full px-3 py-1.5">
                                    {t.metric}
                                </span>
                            </figcaption>
                        </motion.figure>
                    ))}
                </div>
            </div>
        </section>
    );
}
